import { BaseModel } from "@blue-chip/core";
import Client from "./Client";
import Location from "./Location";

export default class Entity extends BaseModel {
  static get belongsTo() {
    return [Client, Location];
  }
}
